import React from "react";

const LANGS = ["fr", "nl", "en", "it"];

export default function LangTabs({ active, onChange }) {
  return (
    <div className="flex gap-1 bg-slate-100 rounded-full p-1 w-fit mb-4">
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => onChange(l)}
          className={`px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider transition-colors ${
            active === l ? "bg-white text-[#2E4DB5] shadow-sm" : "text-slate-500 hover:text-slate-800"
          }`}
          data-testid={`lang-tab-${l}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}

export const LANG_CODES = LANGS;
